var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"itens"},_vm._l((_vm.carrinho),function(item){return _c('li',{key:item.name},[_c('Item',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }